import React from "react"
import Wave, { WaveType } from "../ui/wave"

type Props = {
  html: string
}
const Body = ({ html }: Props) => {
  return (
    <div>
      <Wave pathClassName={"u-c-blue"} type={WaveType.v4} />
      <div className="u-bg-blue u-c-white">
        <section className="container py-5">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </section>
        <Wave className={"u-c-white"} type={WaveType.v1} />
      </div>
    </div>
  )
}

export default Body
